import React, { FC } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import Layout from '../../components/Dashboard/newLayout'
import Billing from './Billing'
import './styles.scss'

interface Props extends RouteComponentProps {
  setIsAuthenticated: (isAuthenticated: boolean) => void
}

const MyCrewDetails: FC<Props> = ({ setIsAuthenticated }) => {
  return (
    <Layout title="My Crew Details" setIsAuthenticated={setIsAuthenticated}>
      <div className="main-container">
        <div className="crew-body">
          <Billing />
        </div>
      </div>
    </Layout>
  )
}

export default withRouter(MyCrewDetails)
